
import qs from 'qs';

export const AddProductToBasket = (api, product, custId, siteId, whId, voucher) => {
  return api.post(`/api/v1/Basket/addProductToBasket?custId=${custId}&siteId=${siteId}&whId=${whId}&voucher=${voucher}`, product)
}

export const UpdateProductInBasket = (api, product, custId, siteId, whId, voucher) => {
  return api.put(`/api/v1/Basket/updateProductInBasket?custId=${custId}&siteId=${siteId}&whId=${whId}&voucher=${voucher}`, product)
}

export const GetBasket = (api, custId, siteId, whId, calculatePrices, voucher, cancelToken) => {
  return api.get(`/api/v1/Basket?custId=${custId}&siteId=${siteId}&whId=${whId}&voucher=${voucher}&calculatePrices=${calculatePrices}`, { cancelToken: cancelToken })
}

export const AddProductsToBasket = (api, products, custId, siteId, whId, replaceCurrentBasket, voucher) => {
  let replaceBasket = replaceCurrentBasket ? true : false

  var data = products.map(prod => ({
    index: prod.index ? prod.index : prod.artNo,
    qtyStock: prod.qty === 0 ? (prod.salesRatio > 0 ? prod.salesRatio : 1) : prod.qty
  }))
  return api.post(`/api/v1/Basket/addProductsToBasket?custId=${custId}&siteId=${siteId}&whId=${whId}&replaceCurrentBasket=${replaceBasket}&voucher=${voucher}`, data)
}

export const DeleteProduct = (api, product, custId) => {
  var data = {
    artNo: product.index
  }
  return api.delete(`/api/v1/Basket?artNo=${product.index}&custId=${custId}`)
}

export const CreateCustomerOrderFromOffer = (api, custId, siteId, whId, deliveryType, notes, deliveryDate, customerInfo, deliveryAddress, receiver, offerNo, offerSiteId, isPh,
  userKod, orderItemsFromOffer, voucher) => {
  var data = getOrderData(custId, siteId, whId, deliveryType, notes, deliveryDate, customerInfo, deliveryAddress, receiver, "", userKod, isPh, null, voucher, orderItemsFromOffer)
  return api.post(`/api/v1/Basket/CreateCustomerOrderFromOffer?offerNo=${offerNo}&offerSiteId=${offerSiteId}`, data)
}

export const RegisterOrder = (api, custId, siteId, whId, deliveryType, notes, deliveryDate, customerInfo, deliveryAddress, receiver, paymentType, userKod, isPh, orderingPerson, voucher) => {
  var data = getOrderData(custId, siteId, whId, deliveryType, notes, deliveryDate, customerInfo, deliveryAddress, receiver, paymentType, userKod, isPh, orderingPerson, voucher, null)
  return api.post(`/api/v1/Basket/CreateCustomerOrder`, data)
}

const getOrderData = (custId, siteId, whId, deliveryType, notes, deliveryDate, customerInfo, deliveryAddress, receiver, paymentType, userKod, isPh, orderingPerson,
  voucher, orderItemsFromOffer = null) => {

  var tmpOrderItems = orderItemsFromOffer ? orderItemsFromOffer.map((item, index) => ({
    Index: item.artNo,
    QtyStock: item.qty,
    OrderPosition: item.product.orderPosition ? item.product.orderPosition : index,
  })) : null

  return {
    custId: custId,
    whId: whId,
    siteId: siteId,
    deliveryType: deliveryType,
    notes: notes ? notes : "",
    receiver: receiver ? receiver : { name: '', surname: '', email: '', phone: '' },
    paymentType: paymentType,
    deliveryDate,
    userKod: userKod ? userKod : '',
    IsPH: isPh ? isPh : false,
    customerInfo: {
      name: customerInfo.Came,
      zipCode: customerInfo.ZipCode,
      city: customerInfo.City,
      street: customerInfo.Street,
      houseNum: customerInfo.HouseNum,
      localNum: customerInfo.LocalNum,
      dpl: customerInfo.Dpl ? customerInfo.Dpl : 0
    },
    deliveryAddress: {
      courierId: deliveryAddress.CourierId.toString(),
      courierName: deliveryAddress.CourierName,
      name: deliveryAddress.Name,
      zipCode: deliveryAddress.ZipCode,
      city: deliveryAddress.City,
      street: deliveryAddress.Street,
      houseNum: deliveryAddress.HouseNum,
      localNum: deliveryAddress.LocalNum,
      phoneNumber: deliveryAddress.PhoneNumber,
      email: deliveryAddress.Email,
    },
    orderingPerson: orderingPerson ? orderingPerson : { name: '', phone: '', email: '' },
    orderItems: tmpOrderItems,
    voucher: voucher ? voucher : '',
  }
}

export const DeleteAllProducts = (api, custId) => {
  return api.delete(`/api/v1/Basket/deleteBasket?custId=${custId}`)
}

export const GetSavedBaskets = (api, custId, siteId, whId) => {
  return api.get(`/api/v1/Basket/getSavedBaskets?custId=${custId}&siteId=${siteId}&whId=${whId}`)
}

export const SaveBasket = (api, basketItems, custId, basketName) => {
  if (basketItems && basketItems[0].product.currency) {
    const data = basketItems.map(item => ({
      index: item.product.index,
      qtyStock: item.qty === null || item.qty === undefined || item.qty === 0 ? 1 : item.qty,
      AddToBasketDate: item.addToBasketDate ? item.addToBasketDate : null,
    }))
    return api.post(`/api/v1/Basket/saveBasket?custId=${custId}&basketName=${basketName}`, data)
  }
  else {
    const data = basketItems.map(item => ({
      index: item.product.index,
      qtyStock: item.product.qty === null || item.product.qty === undefined || item.product.qty === 0 ? 1 : item.product.qty
    }))
    return api.post(`/api/v1/Basket/saveBasket?custId=${custId}&basketName=${basketName}`, data)
  }
}

export const SaveBasketFromOrder = (api, basketItems, custId, basketName) => {
  if (basketItems && basketItems[0].index) {
    const data = basketItems.map(item => ({
      index: item.index,
      qtyStock: item.qtyStock
    }))
    return api.post(`/api/v1/Basket/saveBasket?custId=${custId}&basketName=${basketName}`, data)
  }
}

export const LoadBasket = (api, basketIds, custId, replaceBasket, siteId, whId) => {
  return api.get("/api/v1/Basket/loadBasket", {
    params: {
      basketIds: basketIds,
      custId: custId,
      replaceBasket: replaceBasket,
      siteId: siteId,
      whId: whId
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  })
}

export const DeleteSavedBasket = (api, basketId) => {
  return api.delete(`/api/v1/Basket/deleteSavedBasket?basketId=${basketId}`)
}

export const AddProductToSavedBasket = (api, basketId, products) => {
  var data = products.map(x => ({
    ArtNo: x.product.index,
    Qty: x.product.qty > 0 ? x.product.qty : 1,
  }))
  return api.post(
    `/api/v1/Basket/addProductToSavedBasket?basketId=${basketId}`,
    data
  )
}

export const AddProductToSavedBasketFromOrder = (api, basketId, products) => {
  var data = products.map(x => ({
    ArtNo: x.index,
    Qty: x.qtyStock > 0 ? x.qtyStock : 1,
  }))
  return api.post(
    `/api/v1/Basket/addProductToSavedBasket?basketId=${basketId}`,
    data
  )
}

export const ChangeIsProductSelected = (api, artNo, custId, userId, isSelected) => {
  let data = {
    artNo,
    custId,
    userId,
    isSelected,
  }
  return api.post(`/api/v1/Basket/ChangeIsProductSelected`, data)
}

export const LoadBasketFromOrders = (api, orderIds, custId, replaceBasket, siteId, whId) => {
  return api.get("/api/v1/Basket/LoadBasketFromOrders", {
    params: {
      orderIds: orderIds,
      custId: custId,
      replaceBasket: replaceBasket,
      siteId: siteId,
      whId: whId
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  })
}

export const DeleteProductFromSavedBasket = (api, basketId, artNo) => {
  return api.delete(`/api/v1/Basket/deleteProductFromSavedBasket?basketId=${basketId}&artNo=${artNo}`)
}

export const EditProductsInSavedBasket = (api, products, custId, whId, siteId) => {
  return api.post(`/api/v1/Basket/editProductsInSavedBasket?custId=${custId}&whId=${whId}&siteId=${siteId}`, products)
}

export const AddSingleProductToSavedBasket = (api, basketId, index, qty) => {
  const product = {
    ArtNo: index,
    Qty: qty,
  }
  return api.post(`/api/v1/Basket/addSingleProductToSavedBasket?basketId=${basketId}`, product)
}

export const ChangeSavedBasketName = (api, basketId, name) => {
  var data = {
    BasketId: basketId,
    Name: name,
  }

  return api.post(`/api/v1/Basket/changeSavedBasketName`, data)
}